import { cn } from "@/lib/utils";

interface SectionLabelProps {
  number: string;
  label: string;
  className?: string;
  color?: string;
}

export function SectionLabel({ number, label, className, color }: SectionLabelProps) {
  return (
    <div
      className={cn("flex items-center space-x-2 text-[10px] font-bold tracking-[0.3em]", className)}
      style={color ? { color } : undefined}
    >
      <span>{number}</span>
      <span className="w-6 h-[1px] bg-current" />
      <span>{label}</span>
    </div>
  );
}
